import { IOrder, IPimSnapshot, IReference, IVehicleEquipment, IVehicleOption } from 'next-common';

export interface IMappedConfigFromOrder {
  motorVariant: string;
  utstyrspakke: {
    id: string;
    code: string;
  };
  farge: {
    name: string;
    id: string;
    price: number;
    factoryCodeId: string;
  };
  interior: {
    name: string;
    id: string;
    price: number;
    factoryCodeId: string;
  };
  tillegg: IVehicleEquipment[]; // also includes sales-package, rims, listverk
}

export const mapConfigFromOrder = (order: IOrder): IMappedConfigFromOrder => {
  const pimSnapshot: IPimSnapshot | undefined = order?.pimSnapshot;
  const orderReference: IReference | undefined = order?.orderReference;
  const equipments: IVehicleEquipment[] = order?.equipments || [];
  const options: IVehicleOption[] = order?.options || [];
  const firstOption: IVehicleOption = options?.[0] || ({} as IVehicleOption);

  const config = {
    motorVariant: pimSnapshot?.salesArticle || null,

    utstyrspakke: {
      id: pimSnapshot?.uniqueBrandIdentifier || null,
      code: orderReference?.pimCode || null,
    },

    farge: {
      name: firstOption?.colorName || null,
      id: firstOption?.colorId || null,
      price: firstOption?.colorPrice || 0,
      factoryCodeId: firstOption?.colorFactoryCodeId || null,
    },

    interior: {
      name: firstOption?.interiorName || null,
      id: firstOption?.interiorId,
      price: firstOption?.interiorPrice || 0,
      factoryCodeId: firstOption?.interiorFactoryCodeId || null,
    },

    tillegg: equipments,
  };

  return config;
};

export function modelSeriesToEcomSlug(modelSeries: string): string {
  return modelSeries
    .normalize("NFD")                      // Split accents from letters
    .replace(/[\u0300-\u036f]/g, "")       // Remove diacritics (é → e)
    .trim()                                // Remove leading/trailing spaces
    .replace(/\s+/g, " ")                  // Collapse multiple spaces into one
    .toLowerCase()
    .replace(/\s+/g, "-")                  // Replace spaces with hyphens
    .replace(/-+/g, "-");                   // Collapse multiple hyphens
}